import { SUPPORT_EMAIL } from "constants/index";

import { buildSupportMailtoLink } from "./support";

// Carriers complete verification by emailing their insurance documents to
// support. Shared by the unverified-carrier banner, the profile-completion
// alert, and the carrier shipment views that gate behind verification.
export const CARRIER_VERIFICATION_TOOLTIP = `Send your insurance documents to ${SUPPORT_EMAIL} to complete verification.`;

// The same instruction as a sentence that can follow another one, for surfaces
// that lead with the reason a carrier is blocked before saying what to do.
export const CARRIER_VERIFICATION_INSTRUCTION = `Send your insurance documents to ${SUPPORT_EMAIL} to get verified.`;

export function buildCarrierVerificationMailtoLink(
  companyName: string,
): string {
  return buildSupportMailtoLink(
    `${companyName} Insurance Documents Verification Package`,
  );
}
